import LOGO from './logo/logo_symbol.png';
import LOGO_HORIZONTAL from './logo/logo_horizontal.png';
import SYMBOL from './symbol/symbol-kmg@3x.png';
import RNC_LOGO from './logo/labels_rnc_color_left.png';
import HANDMADE_LOGO from './logo/labels_handmade_color_left.png';
import HIGHBRID_LOGO from './logo/labels_highbrid_color_left.png';

import ajm1 from './ajm/profile/1.jpeg';
import ajm2 from './ajm/profile/2.png';
import ajm3 from './ajm/profile/3.jpeg';
import ajm4 from './ajm/profile/4.jpeg';

import cwk1 from './cwk/profile/cwk-profile-01.webp';
import cwk2 from './cwk/profile/cwk-profile-02.webp';

import ghe1 from './ghe/profile/1.jpg';
import ghe2 from './ghe/profile/2.jpg';
import ghe3 from './ghe/profile/3.jpg';
import ghe4 from './ghe/profile/4.jpg';

import jhs1 from './jhs/profile/1.jpg';
import jhs2 from './jhs/profile/2.jpg';
import jhs3 from './jhs/profile/3.jpg';
import jhs4 from './jhs/profile/4.jpg';

import jns1 from './jns/profile/1.jpg';
import jns2 from './jns/profile/2.jpg';
import jns3 from './jns/profile/3.jpg';
import jns4 from './jns/profile/4.jpg';

import krn1 from './krn/profile/krn-profile-01.webp';
import krn2 from './krn/profile/krn-profile-02.webp';
import krn3 from './krn/profile/krn-profile-03.webp';
import krn4 from './krn/profile/krn-profile-04.webp';
import krn5 from './krn/profile/krn-profile-05.webp';
import krn6 from './krn/profile/krn-profile-06.webp';
import krn7 from './krn/profile/krn-profile-07.webp';
import krn8 from './krn/profile/krn-profile-08.webp';
import krn9 from './krn/profile/krn-profile-09.webp';

import kbb1 from './kbb/profile/kbb-profile-01.webp';
import kbb2 from './kbb/profile/kbb-profile-02.webp';
import kbb3 from './kbb/profile/kbb-profile-03.webp';
import kbb4 from './kbb/profile/kbb-profile-04.webp';
import kbb5 from './kbb/profile/kbb-profile-05.webp';

import lsk1 from './lsk/profile/lsk-profile-01.webp';
import lsk2 from './lsk/profile/lsk-profile-02.webp';
import lsk3 from './lsk/profile/lsk-profile-03.webp';
import lsk4 from './lsk/profile/lsk-profile-04.webp';
import lsk5 from './lsk/profile/lsk-profile-05.webp';
import lsk6 from './lsk/profile/lsk-profile-06.webp';

import oskar1 from './oskar/profile/oskar-profile-01.webp';
import oskar2 from './oskar/profile/oskar-profile-02.webp';

const ajmProfile = [ ajm1, ajm2, ajm3, ajm4 ];
const cwkProfile = [ cwk1, cwk2 ];
const gheProfile = [ ghe1, ghe2, ghe3, ghe4 ];
const jhsProfile = [ jhs1, jhs2, jhs3, jhs4 ];
const jnsProfile = [ jns1, jns2, jns3, jns4 ];
const krnProfile = [ krn1, krn2, krn3, krn4, krn5, krn6, krn7, krn8, krn9 ];
const kbbProfile = [ kbb1, kbb2, kbb3, kbb4, kbb5 ];
const lskProfile = [ lsk1, lsk2, lsk3, lsk4, lsk5, lsk6 ];
const oskarProfile = [ oskar1, oskar2 ];

const LABELS = {
  RNC: RNC_LOGO,
  HANDMADE: HANDMADE_LOGO,
  HIGHBRID: HIGHBRID_LOGO,
};

export {
  LOGO,
  LOGO_HORIZONTAL,
  SYMBOL,
  LABELS,

  ajmProfile,
  cwkProfile,
  gheProfile,
  jhsProfile,
  jnsProfile,
  krnProfile,
  kbbProfile,
  lskProfile,
  oskarProfile,
};
